import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import Skeleton from '@mui/material/Skeleton';

import { useTranslation } from 'react-i18next';

import { useDetailsViewContext } from '../DetailsViewContext';

/**
 * Header component with resource name and optional menu button
 */
export default function ResourceHeader(/* props */) {
  const { t } = useTranslation();

  const {
    publicData,
    showResourceSelect,
    openResourcePage,
    isSticky = false,
  } = useDetailsViewContext();

  const label = useMemo(() => {
    const name = publicData?.resource?.name;
    if (!name) {
      return t('detailsView.res_name_placeholder');
    } else if (name && name === t('common.All')) {
      return t('detailsView.res_name_placeholder');
    }

    return name;
  }, [publicData?.resource?.name, t]);

  return (
    <Grid id="resource-header" item container xs={12}>
      <Grid
        item
        xs
        zeroMinWidth
        sx={[
          {
            alignSelf: 'center',
          },
          isSticky
            ? {
                position: 'sticky',
                top: 0,
                background: '#fff',
              }
            : {},
        ]}
      >
        <Typography variant="h4" component="h2" sx={{ m: 0 }}>
          {label}
        </Typography>
      </Grid>
      {showResourceSelect && (
        <Grid
          item
          xs="auto"
          sx={{
            pb: 1,
          }}
        >
          <Button
            size="small"
            onClick={openResourcePage}
            color="primary"
            variant="outlined"
            sx={{
              padding: '1px 0',
              minWidth: '44px',
              float: 'right',
            }}
          >
            <MenuIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

export function ResourceHeaderSkeleton() {
  return <Skeleton variant="text" width="60%" height={40} />;
}
